import { render, staticRenderFns } from "./HighValueBuybackRecords.vue?vue&type=template&id=70d44874&scoped=true&"
import script from "./HighValueBuybackRecords.vue?vue&type=script&lang=js&"
export * from "./HighValueBuybackRecords.vue?vue&type=script&lang=js&"
import style0 from "./HighValueBuybackRecords.vue?vue&type=style&index=0&id=70d44874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d44874",
  null
  
)

export default component.exports